import service from '@/store/services/biotimes/biometric-whitelists-service';

const state = {
    list: [],
    whitelistItem: null,
    meta: {},
    isLoading: false,
    error: null
};

const mutations = {
    SET_LIST(state, list) {
        state.list = list;
    },
    SET_RESOURCE(state, whitelistItem) {
        state.whitelistItem = whitelistItem;
    },
    SET_META(state, meta) {
        state.meta = meta;
    },
    SET_LOADING(state, status) {
        state.isLoading = status;
    },
    SET_ERROR(state, error) {
        state.error = error;
    }
};

const actions = {
    list({ commit }, params = {}) {
        commit('SET_LOADING', true);
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
                commit('SET_LOADING', false);
                return { list, meta };
            })
            .catch(error => {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    get({ commit }, id) {
        commit('SET_LOADING', true);
        return service.get(id)
            .then(whitelistItem => {
                commit('SET_RESOURCE', whitelistItem);
                commit('SET_LOADING', false);
                return whitelistItem;
            })
            .catch(error => {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    add({ commit, dispatch }, params) {
        commit('SET_LOADING', true);
        return service.add(params)
            .then((whitelistItem) => {
                commit('SET_RESOURCE', whitelistItem);
                commit('SET_LOADING', false);
                dispatch('list');
                return whitelistItem;
            })
            .catch(error => {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    update({ commit, dispatch }, params) {
        commit('SET_LOADING', true);
        return service.update(params)
            .then((whitelistItem) => {
                commit('SET_RESOURCE', whitelistItem);
                commit('SET_LOADING', false);
                dispatch('list');
                return whitelistItem;
            })
            .catch(error => {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    destroy({ commit, dispatch }, id) {
        commit('SET_LOADING', true);
        return service.destroy(id)
            .then(() => {
                commit('SET_LOADING', false);
                dispatch('list');
                return true;
            })
            .catch(error => {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    clearError({ commit }) {
        commit('SET_ERROR', null);
    }
};

const getters = {
    list: state => state.list,
    meta: state => state.meta,
    listTotal: state => state.meta.page.total,
    whitelistItem: state => state.whitelistItem,
    isLoading: state => state.isLoading,
    error: state => state.error,
    activeWhitelists: state => state.list.filter(item => item.is_active),
    expiredWhitelists: state => state.list.filter(item => !item.is_active && item.end_date),
    byTargetType: (state) => (type) => {
        return state.list.filter(item => item.target_type === type);
    }
};

const biometricWhitelists = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default biometricWhitelists;